import { useMutation, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { ProjectDto, UpdateProjectDto } from 'src/Services/API/generated/api';
import { trackEvent } from 'src/Services/Matomo';

const useUpdateProject = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ projectId, data }: { projectId: string; data: UpdateProjectDto }) =>
      projectsApi.projectsControllerUpdate(projectId, assetId, data),
    {
      onMutate: async ({ projectId, data }) => {
        await queryClient.cancelQueries(['projects', assetId]);
        const previousProjects = queryClient.getQueryData<ProjectDto[]>(['projects', assetId]);

        if (previousProjects) {
          queryClient.setQueryData<ProjectDto[]>(['projects', assetId], old => {
            return (old || []).map(p =>
              p.id === projectId ? ({ ...p, ...data } as ProjectDto) : p
            );
          });
        }

        return { previousProjects };
      },
      onError: (_err, _variables, context) => {
        if (context?.previousProjects) {
          queryClient.setQueryData(['projects', assetId], context.previousProjects);
        }
      },
      onSuccess: () => {
        trackEvent('Project', 'update');
      },
      onSettled: () => {
        queryClient.invalidateQueries(['projects', assetId]);
        queryClient.invalidateQueries(['fetch-events']);
      },
    }
  );
};

export default useUpdateProject;
